export default __webpack_public_path__ + "static/media/sertifikat_keanggotaan_new.dc4bf8f8.png";